//-- React Standard
import React, { Component } from "react";
import { connect } from 'react-redux';
import Moment, { now } from 'moment';
import config from '../../config';

//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import Footer from "../Common/Footer/Footer";
import { apiConstants } from '../../_constants/api.constants';
import Pagination from "../Common/Pagination/Pagination";
import PageLimit from "../Common/PageLimit/PageLimit";
import DeletePopup from "../Common/Popup/DeletePopup";
import ViewPopup from "../Common/Popup/ViewPopup";
import EditPopup from "../Common/Popup/EditPopup";
import { userActions } from "../../_actions";

class Coupon extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sort: {
                sortKey: null,
                direction: 'desc',
            },
            totalPage: '',
            totalDataCount: '',
            currentPage: 1,
            getCouponList: [],
            viewOpen: false,
            editOpen: false,
            deleteOpen: false,
            advertisments: {
                title: '',
                advertisment_image: '',
            },
            popupType: '',
            addButton: false,
        };
    }

    /*
    * componentDidMount - Initially it will call and get the advertisments data
    */
    componentDidMount() {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        var userId = JSON.parse(sessionStorage.getItem("user"))._id;
        var role = JSON.parse(sessionStorage.getItem("user")).role_type;
        if (role[0] === 'shopkeeper') { postData.shopkeeperId = userId; }
        if (role[0] === 'admin') { }

        dispatch(userActions.getCoupounList(apiConstants.GET_COUPOUN, postData));
    }

    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
    componentWillReceiveProps(props) {
        if (props.getCoupounList) {
            if (props.getCoupounList.getCoupounList) {
                if (props.getCoupounList.getCoupounList.data.data) {
                    console.log("coupon", props.getCoupounList.getCoupounList.data.data);
                    this.setState({
                        totalPage: props.getCoupounList.getCoupounList.data.data.totalPages,
                        totalDataCount: props.getCoupounList.getCoupounList.data.data.totalCount,
                        getCouponList: props.getCoupounList.getCoupounList.data.data.data,
                    })
                }
            }
        }
    }

    /*
    *   Pagination function: It will call from pagination section and change data in table
    */
    makeHttpRequestWithPage = (pageNumber) => {
        const { dispatch } = this.props;
        this.setState({
            currentPage: pageNumber
        });

        let postData = {};
        postData.page = pageNumber;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;
        var userId = JSON.parse(sessionStorage.getItem("user"))._id;
        var role = JSON.parse(sessionStorage.getItem("user")).role_type;
        if (role[0] === 'shopkeeper') { postData.shopkeeperId = userId; }

        dispatch(userActions.getCoupounList(apiConstants.GET_COUPOUN, postData));
    }

    // get coupon list based on changed per page limit
    changeTableData = (e) => {
        const { dispatch } = this.props;

        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = parseInt(e.target.value);

        dispatch(userActions.getCoupounList(apiConstants.GET_COUPOUN, postData));
    }

    /*
    * searchAdvertisments - User can search data from the database and it will appear
    */
    searchAdvertisments(keyword) {
        const { dispatch } = this.props;
        let postData = {};
        postData.page = 1;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        var userId = JSON.parse(sessionStorage.getItem("user"))._id;
        var role = JSON.parse(sessionStorage.getItem("user")).role_type;
        if (role[0] === 'shopkeeper') { postData.shopkeeperId = userId; }

        if (keyword.target.value !== '') {
            postData.qwery = keyword.target.value;
            dispatch(userActions.getCoupounList(apiConstants.SEARCH_COUPOUN, postData));
        } else {
            dispatch(userActions.getCoupounList(apiConstants.GET_COUPOUN, postData));
        }



    }

    //-- Popup Handler
    /*
    *   Modal open-close functionality
    */
    popupOpen = (advertisments, type, btnClick) => {
        //-- check add button clicked
        if (btnClick === 'addButton') {
            this.setState({ addButton: true });
            this.setState({ popupType: 'AddCoupon' })
        }
        this.setState({ advertisments, [type]: true })
    };

    EditPopupOpen = (couponData, type) => {
        this.setState({
            data: couponData,
            popupType: 'EditCoupon',
            addButton: true
        });

        this.setState({ [type]: true })
    }


    DeletePopupOpen = (couponId, type) => {
        this.setState({
            deleteId: couponId
        });

        this.setState({ [type]: true })
    }
    /*
    *   Close the popup
    */
    popupClose = (type) => {
        this.setState({
            advertisments: {
                title: '',
                type: '',
                advertisment_image: '',
            },
            addButton: false,
            [type]: false
        });
    };

    /*
    *   We are handling validation from this function
    */
    handleValidation(data) {
        const { siteConstants } = this.props.language;

        let fields = data.defaultData;
        let errors = {};
        let formIsValid = true;
        //Name
        if ((fields["title"] == '')) {
            formIsValid = false;
            if (fields["title"] == '') {
                errors["title"] = siteConstants.ERR_CAN_NOT_BLANK;
            }
        }

        if (!fields["title"]) {
            if (!fields["title"].match(/^[a-zA-Z]+$/)) {
                formIsValid = false;
                errors["title"] = siteConstants.ERR_ONLY_LETTERS;
            }
        }
        return ({ errors, formIsValid });
    }

    // /*
    // *   Advertisments can add/edit from this area
    // */
    // advertismentsAddUpdate = (e, data) => {
    //     e.preventDefault();

    //     if (this.handleValidation(data).formIsValid) {
    //         let postData = {};
    //         postData.page = 1;
    //         postData.orderBy = "id";
    //         postData.orderByAscDesc = "ASC";

    //         //this.props.dispatch(advertismentActions.addUpdateAdvertisment(apiConstants.ADD_UPDATE_ADVERTISMENT_DATA, data.defaultData, apiConstants.GET_ADVERTISMENTS, postData));
    //         this.popupClose('editOpen');

    //         return ({ errors: {}, formIsValid: true });
    //     } else {
    //         return this.handleValidation(data);
    //     }
    // }

    /*
        we can remove the selected data, using the below function
    */
    deleteCoupon = (couponId) => {
        let postData = {};
        postData.page = this.state.currentPage;
        postData.orderBy = "id";
        postData.orderByAscDesc = "ASC";
        postData.perPage = config.perPageData;

        var userId = JSON.parse(sessionStorage.getItem("user"))._id;
        var role = JSON.parse(sessionStorage.getItem("user")).role_type;
        if (role[0] === 'shopkeeper') { postData.shopkeeperId = userId; }

        let obj = {};
        obj.id = couponId;
        this.props.dispatch(userActions.deleteCoupon(apiConstants.DELETE_COUPON, obj, apiConstants.GET_COUPOUN, postData));
        this.popupClose('deleteOpen');
    }

    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div id="wrapper">
                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_COUPON}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">

                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <h1 className="h3 mb-0 text-gray-800">{siteConstants.MENU_COUPON}</h1>
                                <a href="javascript:void(0)" onClick={() => this.popupOpen(this.state.advertisments, 'editOpen', 'addButton')}>
                                    <span className="text">
                                        <button className="btn btn-primary">{siteConstants.BTN_ADD}</button>
                                    </span>
                                </a>
                            </div>


                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    {/* style={{"overflowY": "scroll"}} */}
                                    <div className="table-responsive" >
                                        <div className="row">
                                            {/* Page limit drop down */}
                                            <PageLimit changeLimit={(e) => this.changeTableData(e)} />

                                            <div className="col-sm-12 col-md-6">
                                                <div id="dataTable_filter" className="dataTables_filter">
                                                    <label>
                                                        <input type="search" palaceholder={siteConstants.GEN_SEARCH} className="form-control form-control-sm" placeholder="" aria-controls="dataTable" onChange={(e) => this.searchAdvertisments(e)} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <table className="table table-bordered" width="100%" cellSpacing="0">
                                            <thead>
                                                <tr>
                                                    <th scope="col" width="5%">{siteConstants.GEN_NUMBER}</th>
                                                    <th scope="10%">{siteConstants.GEN_COUPON_TOKEN}</th>
                                                    <th scope="10%">{siteConstants.GEN_TITLE}</th>
                                                    {/* <th scope="col">{siteConstants.GEN_DESCRIPTION}</th> */}
                                                    <th scope="col">{siteConstants.GEN_TYPE}</th>
                                                    <th scope="col">{siteConstants.GEN_VALUE}</th>
                                                    <th scope="col">{siteConstants.GEN_EXPIRY_DATE}</th>
                                                    <th scope="col">{siteConstants.LABEL_STATUS}</th>
                                                    <th width="10%">{siteConstants.LABEL_ACTION}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.state.getCouponList != undefined && this.state.getCouponList.length > 0 ? this.state.getCouponList.map((coupon, index) => {
                                                        let couponExpiry = new Date(coupon.expiry);
                                                        return (
                                                            <tr key={index}>
                                                                <td scope="row">{index + 1}</td>
                                                                <td>{coupon.coupon_token}</td>
                                                                <td>{coupon.coupon_title}</td>
                                                                {/* <td>{coupon.description}</td> */}
                                                                <td>{coupon.couponType}</td>
                                                                <td>{coupon.couponValue}</td>
                                                                <td>  {couponExpiry !== undefined ? couponExpiry.toLocaleString("en-US", options) : ''}</td>
                                                                <td>{coupon.status}</td>
                                                                <td className="tdTextCenter">
                                                                    {Moment(Moment().format()).isBefore(coupon.expiry) ?
                                                                        <a className="actionIcon" title="Edit" href="javascript:void(0)" onClick={() => this.EditPopupOpen(coupon, 'editOpen')}><span><img src="assets/img/svg/EditIcon.png" alt="Edit" /></span></a>
                                                                        : ''}
                                                                    <a className="actionIcon" title="Delete" href="javascript:void(0)" onClick={() => this.DeletePopupOpen(coupon._id, 'deleteOpen', 'deleteClick')}><span><img src="assets/img/svg/Bin.png" alt="Delete" /></span></a>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }) : <tr>
                                                        <td colSpan="8" className="noRecordFound">{siteConstants.GEN_NO_RECORD}</td>
                                                    </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {/* calling the another componenet */}
                                    <Pagination totalPage={this.state.totalPage} currentPage={this.state.currentPage} funPagination={this.makeHttpRequestWithPage} />



                                </div>
                            </div>

                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>

                {/* Start Popup -View advertisments details  */}
                <ViewPopup popupType="AdvertismentsComponenet" viewOpen={this.state.viewOpen} advertisments={this.state.advertisments} funPopupClose={this.popupClose} />
                {/* End Popup -View advertisments details  */}

                {/* Start Popup -Edit advertisments details  */}
                <EditPopup
                    popupType={this.state.popupType}
                    userData={this.state.data}
                    currentPage={this.state.currentPage}
                    addButton={this.state.addButton}
                    editOpen={this.state.editOpen}
                    funPopupClose={this.popupClose}
                    funAdvertismentsAddUpdate={(e, data) => this.advertismentsAddUpdate(e, data)}
                    defaultData={this.state.advertisments}
                />
                {/* End Popup -Edit advertisments details  */}
                {/* Delete popup */}
                <DeletePopup deleteOpen={this.state.deleteOpen} deleteId={this.state.deleteId} funPopupClose={this.popupClose} funDelete={this.deleteCoupon} />
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { getCoupounList, language } = state;
    return {
        getCoupounList,
        language
    };
}

const connectedCoupon = connect(mapStateToProps)(Coupon);
export { connectedCoupon as Coupon };
